// #368: a selection where the order of the taps is the point. The diary's
// sessions become a program's days in the order they were picked, so the
// number beside a picked row is its position here. Pure.

/** `id` added at the end, or taken out: the ones after it move up one. */
export const toggleOrdered = (ids: readonly string[], id: string): string[] =>
  ids.includes(id) ? ids.filter((x) => x !== id) : [...ids, id];

/** 1-based position of `id`, or undefined when it is not picked. */
export const orderOf = (ids: readonly string[], id: string): number | undefined => {
  const i = ids.indexOf(id);
  return i < 0 ? undefined : i + 1;
};
